import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=2a881839&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=2a881839&prod&lang=css"
import style1 from "./LoginPage.vue?vue&type=style&index=1&id=2a881839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a881839",
  null
  
)

export default component.exports